import React, { useState, useEffect, useContext } from 'react';
import { Stack, Autocomplete, Typography, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AccordionSummary, AccordionDetails, Accordion } from '../shared/components/accordion';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormMode, GenderList } from '../utils/extensions/constantEx';
import { GetDayJSValueFromUTCDate } from '../utils/extensions/functionEx';
import { HomeContext } from '../utils/contexts/homeContext';
import { EmployeeFormContext } from '../utils/contexts/employeeFormContext';
import EmployeeAddress from './employeeAddress';
import dayjs from 'dayjs';

const EmployeePersonalInfo = (props) => {

    const { formOpenMode, isShowValidationMsgs } = props;

    const { OpenErrorAlert, homeState } = useContext(HomeContext);
    const { employeeFormValue, selectedEmployeeJson, SetEmployeeFormValue } = useContext(EmployeeFormContext);

    const [cleared, setCleared] = useState(false);
    const [dob, setDOB] = useState(null);
    const [age, setAge] = useState(0);
    const [selectedGender, setSelectedGender] = useState(GenderList[1]);
    const [spouseName, setSpouseName] = useState('');
    const [fatherName, setFatherName] = useState('');
    const [motherName, setMotherName] = useState('');
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if ((formOpenMode === FormMode.ViewMode || formOpenMode === FormMode.EditMode) && selectedEmployeeJson && selectedEmployeeJson.id > 0) {
            setDOB(GetDayJSValueFromUTCDate(selectedEmployeeJson.dob));
            setSpouseName(selectedEmployeeJson.spouse_name);
            setFatherName(selectedEmployeeJson.father_name);
            setMotherName(selectedEmployeeJson.mother_name);
            setNotes(selectedEmployeeJson.notes);

            const tempReligions = homeState.religions.filter(col => col.id === selectedEmployeeJson.religion_id);
            if (tempReligions.length > 0) {
                setSelectedReligion(tempReligions[0]);
            } else {
                setSelectedReligion(null);
            }

            if (GenderList[1].id === selectedEmployeeJson.gender) {
                setSelectedGender(GenderList[1]);
            } else if (GenderList[0].id === selectedEmployeeJson.gender) {
                setSelectedGender(GenderList[0]);
            }
        } else {
            setDOB(null);
            setAge(0);
            setSelectedGender(GenderList[1]);
            setSpouseName('');
            setFatherName('');
            setMotherName('');
            setNotes('');
            setSelectedReligion(null);
        }
    }, [formOpenMode, selectedEmployeeJson]);

    // useEffect(() => {
    //     if ((formOpenMode === FormMode.ViewMode || formOpenMode === FormMode.EditMode) && selectedNurseJosn && selectedNurseJosn.id > 0) {
    //         setSpouseName(selectedNurseJosn.spouse_name);
    //         setFatherName(selectedNurseJosn.father_name);
    //         setMotherName(selectedNurseJosn.mother_name);
    //         setPoliceStation(selectedNurseJosn.police_station);
    //         setEducation(selectedNurseJosn.education);
    //         setLanguagesKnown(selectedNurseJosn.police_station);
    //         setHeight(selectedNurseJosn.height > 0 ? selectedNurseJosn.height.toString() : '');
    //         setColour(selectedNurseJosn.colour);
    //         setBankAccount(selectedNurseJosn.bank_account);
    //         setNotes(selectedNurseJosn.notes);
    //         setDOB(GetDayJSValueFromUTCDate(selectedNurseJosn.dob));

    //         const tempReligions = religions.filter(col => col.id === selectedNurseJosn.religion_id);
    //         if (tempReligions.length > 0) {
    //             setSelectedReligion(tempReligions[0]);
    //         } else {
    //             setSelectedReligion(null);
    //         }

    //         if (GenderList[1].id === selectedNurseJosn.gender) {
    //             setSelectedGender(GenderList[1]);
    //         } else if (GenderList[0].id === selectedNurseJosn.gender) {
    //             setSelectedGender(GenderList[0]);
    //         }
    //     }
    // }, [selectedNurseJosn, formOpenMode]);

    useEffect(() => {
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);

            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [cleared]);

    useEffect(() => {
        let tempAge = 0;
        if (dob) {
            tempAge = dayjs().year() - dob.year();
        }
        setAge(tempAge);
    }, [dob]);

    useEffect(() => {
        handleFormValueChange();
    }, [selectedGender, selectedReligion, spouseName, fatherName, motherName, dob, notes]);

    const handleFormValueChange = () => {
        try {
            const tempEmployee = { ...employeeFormValue };

            tempEmployee.dob = dob;
            tempEmployee.spouseName = spouseName;
            tempEmployee.fatherName = fatherName;
            tempEmployee.motherName = motherName;
            tempEmployee.notes = notes;
            tempEmployee.genderId = selectedGender && selectedGender.id ? selectedGender.id : 0;
            tempEmployee.religionId = selectedReligion && selectedReligion.id ? selectedReligion.id : 0;

            SetEmployeeFormValue(tempEmployee);
        }
        catch (error) {
            OpenErrorAlert(error);
        }
    }

    return (

        <Accordion defaultExpanded>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-personal-info-content"
                id="panel-personal-info"
            >
                <Typography component="span">Personal Info</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack spacing={2}>
                    <Grid container spacing={1}>
                        <Grid size={3}>
                            <DatePicker readOnly={formOpenMode === FormMode.ViewMode} format="DD/MM/YYYY"
                                label="DOB" maxDate={dayjs().add(-18, 'year')} minDate={dayjs().add(-80, 'year')}
                                value={dob}
                                onChange={(newValue) => { setDOB(newValue); }}
                                slotProps={{
                                    textField: {
                                        size: "small", fullWidth: true, required: true,
                                        error: isShowValidationMsgs && !dob ? true : false,
                                        helperText: isShowValidationMsgs && !dob ? 'Enter DOB' : 'DD/MM/YYYY'
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => setCleared(true)
                                    }
                                }}
                            />
                        </Grid>
                        <Grid size={1}>
                            <TextField size="small" fullWidth label="Age" type="number" value={age}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Autocomplete readOnly={formOpenMode === FormMode.ViewMode}
                                id="combo-box-gender" disableClearable
                                options={GenderList} value={selectedGender}
                                getOptionLabel={(option) => option.label}
                                onChange={(event, newValue) => {
                                    setSelectedGender(newValue);
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label="Gender" size="small" fullWidth required
                                        error={isShowValidationMsgs && !selectedGender ? true : false}
                                        helperText={isShowValidationMsgs && !selectedGender ? 'Select gender' : ''} />}
                            />
                        </Grid>
                        <Grid size={4}>
                            <Autocomplete readOnly={formOpenMode === FormMode.ViewMode}
                                id="combo-box-religion"
                                options={homeState.religions}
                                value={selectedReligion}
                                getOptionLabel={(option) => option.religion_name}
                                onChange={(event, newValue) => {
                                    setSelectedReligion(newValue);
                                }}
                                renderInput={(params) =>
                                    <TextField {...params} label="Religion" size="small" fullWidth required
                                        error={isShowValidationMsgs && !selectedReligion ? true : false}
                                        helperText={isShowValidationMsgs && !selectedReligion ? 'Select religion' : ''}
                                    />}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Spouse Name"
                                value={spouseName}
                                onChange={(event) => {
                                    setSpouseName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Father Name"
                                value={fatherName}
                                onChange={(event) => {
                                    setFatherName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                        <Grid size={4}>
                            <TextField size="small" fullWidth
                                label="Mother Name"
                                value={motherName}
                                onChange={(event) => {
                                    setMotherName(event.target.value);
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={1}>
                        <Grid size={6}>
                            <EmployeeAddress panelId="employee-address1-panel-content" headerText="Address 1" isShowValidationMsgs={isShowValidationMsgs}
                                formOpenMode={formOpenMode}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField size="small" fullWidth multiline rows={12}
                                label="Notes"
                                value={notes}
                                onChange={(event) => {
                                    setNotes(event.target.value ?? '');
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: formOpenMode === FormMode.ViewMode
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
}

export default EmployeePersonalInfo;
